import { render, staticRenderFns } from "./cheif_pattern_making_officier_home.vue?vue&type=template&id=1c5bfc40"
import script from "./cheif_pattern_making_officier_home.vue?vue&type=script&lang=js"
export * from "./cheif_pattern_making_officier_home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports